import cx from 'classnames';
import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import Coin from 'components/Coin';
import Glyph from 'components/Glyph';
import MediaObject from 'components/MediaObject';
import NameAndSignatureQuery from 'components/NameAndSignatureQuery';
import PotentialChatMember from 'entities/PotentialChatMember';
import Text from 'components/Text';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities';
import UserAvatar from 'users/components/UserAvatar';
import IndividualRecipientAvatar from 'chat_v2/components/IndividualRecipientAvatar';
import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';

import './styles/MessageStarterItem.scss';

class MessageStarterItem extends React.Component<
  {
    entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity,
    selectable: boolean,
    selected: boolean,
    query: string,
    className?: string,
  }
> {
  static defaultProps = {
    selectable: false,
    selected: false,
  };

  shouldComponentUpdate(nextProps: Object): boolean {
    // HACK assumes `member` doesn't mutate during the life of this component
    return shallowCompare(this, nextProps, this.state);
  }

  renderDroplet() {
    if (this.props.selectable) {
      if (this.props.selected) {
        return (
          <Coin className="MessageStarterItem-droplet" color="mascot" size="xxxlarge">
            <Glyph name="check" color="whiteout" size="large" solo />
          </Coin>
        );
      } else {
        return <Coin className="MessageStarterItem-droplet" border="percussion" size="xxxlarge" />;
      }
    }

    const { entity } = this.props;

    return <IndividualRecipientAvatar size="medium" entity={entity} />;
  }

  render() {
    const { entity, query } = this.props;
    const parser = TextEntities.createTextMatchingParser(query);

    return (
      <a className={cx('MessageStarterItem', this.props.className)}>
        <MediaObject center figure="right" className="MessageStarterItem-inner">
          <MediaObject center gutter="small">
            {this.renderDroplet()}
            <div>
              <NameAndSignatureQuery
                displayName={entity.content.title}
                fullName={entity.content.title}
                query={query}
              />
            </div>
          </MediaObject>
          <div />
        </MediaObject>
      </a>
    );
  }
}

export default MessageStarterItem;
